import React, { useState, useEffect } from 'react';
import componentStyles from './actionBar.module.css';
import eventBus from '../../service/eventBus';
import { EVENT_UPDATE_ACTION_BAR_VIEW, EVENT_UPDATE_AUTHENTICATED } from '../../utils/constants';
import { FaBullseye, FaCalculator, FaCog, FaDoorOpen, FaFlask, FaLayerGroup, FaUser } from 'react-icons/fa';
import AnalyticsService from '../../service/analyticsService';
import { EVENT_VIEW_CHANGED } from '../../utils/analyticsConstants';
import AccessService from '../../service/accessService';

const ActionBar = () => {
    const componentId = 'ActionBar';
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [currentView, setCurrentView] = useState('snipedOdds'); // Track current active view
    const canUseModels = AccessService.getInstance().isProOrAdmin();

    const handleViewChange = (view) => {
        const nextView = view === 'feed' ? 'props' : view;
        console.log('Action Bar: handleViewChange', nextView);
        AnalyticsService.getInstance().track(EVENT_VIEW_CHANGED, { view: nextView });
        AnalyticsService.getInstance().setViewContext(nextView, currentView);
        setCurrentView(nextView); // Update local state for visual feedback
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, nextView);
    }

    const handleViewChangeEvent = (view) => {
        // Listen to view changes from other components (like Home)
        const nextView = view === 'feed' ? 'props' : view;
        console.log('Action Bar: Received view change event', nextView);
        setCurrentView(nextView);
    }

    const handleAuthenticated = (authenticated) => {
        console.log('Action Bar: handleAuthenticated', authenticated);
        setIsAuthenticated(authenticated);
        // Picks is being sunset, so use Sniped as the default visible view.
        setCurrentView('snipedOdds');
    }

    useEffect(() => {
        // Listen to view change events to keep ActionBar in sync
        eventBus.on(componentId, EVENT_UPDATE_ACTION_BAR_VIEW, handleViewChangeEvent);
        eventBus.on(componentId, EVENT_UPDATE_AUTHENTICATED, handleAuthenticated);

        return () => {
            eventBus.off(componentId, EVENT_UPDATE_ACTION_BAR_VIEW);
            eventBus.off(componentId, EVENT_UPDATE_AUTHENTICATED);
        };
    }, []);

    return (
        <div className={componentStyles.actionBar}>
            {isAuthenticated ? (
                <>
                    <button 
                        onClick={() => handleViewChange('snipedOdds')}
                        className={currentView === 'snipedOdds' ? componentStyles.active : ''}
                    > 
                        <FaBullseye /> <br /> Sniped 
                    </button>
                    <button
                        onClick={() => handleViewChange('research')}
                        className={currentView === 'research' ? componentStyles.active : ''}
                    >
                        <FaFlask /> <br /> Research
                    </button>
                    {canUseModels && (
                        <button
                            onClick={() => handleViewChange('models')}
                            className={currentView === 'models' ? componentStyles.active : ''}
                        >
                            <FaCalculator /> <br /> Models
                        </button>
                    )}
                    <button 
                        onClick={() => handleViewChange('parlay')}
                        className={currentView === 'parlay' ? componentStyles.active : ''}
                    > 
                        <FaLayerGroup /> <br /> Parlay 
                    </button>
                    <button 
                        onClick={() => handleViewChange('settings')}
                        className={currentView === 'settings' ? componentStyles.active : ''}
                    > 
                        <FaCog /> <br /> Settings 
                    </button>
                    <button 
                        onClick={() => handleViewChange('profile')}
                        className={currentView === 'profile' ? componentStyles.active : ''}
                    > 
                        <FaUser /> <br /> Profile 
                    </button>
                </>
            ) : (
                <>
                    <button 
                        onClick={() => handleViewChange('snipedOdds')}
                        className={currentView === 'snipedOdds' ? componentStyles.active : ''}
                    > 
                        <FaBullseye /> <br /> Sniped 
                    </button>
                    <button
                        onClick={() => handleViewChange('research')}
                        className={currentView === 'research' ? componentStyles.active : ''}
                    >
                        <FaFlask /> <br /> Research
                    </button>
                    <div className={componentStyles.spacer}></div>
                    <button 
                        onClick={() => handleViewChange('login')}
                        className={currentView === 'login' ? componentStyles.active : ''}
                    > 
                        <FaDoorOpen /> <br /> Login 
                    </button>
                </>
            )}
        </div>
    )
}

export default ActionBar;
